import React from 'react';
import { About } from '../components/About';
import { ContactForm } from '../components/ContactForm';
import { Faq } from '../components/Faq';
import { Footer } from '../components/Footer';
import { Hero } from '../components/Hero';
import { HowItWorks } from '../components/HowItWorks';
import { Navbar } from '../components/Navbar';
import { ProjectShowcase } from '../components/ProjectShowcase';
import { Services } from '../components/Services';
import { Testimonials } from '../components/Testimonials';
import { TrustBar } from '../components/TrustBar';
import { WhatsAppFloat } from '../components/WhatsAppFloat';
import { WhyChooseUs } from '../components/WhyChooseUs';
interface HomeProps {
  showTrustBar: boolean;
  showProcessSteps: boolean;
}
export function Home({
  showTrustBar,
  showProcessSteps
}: HomeProps) {
  return <div className="w-full bg-white" data-id="element-305" data-mp="3kuijbji3ss8y">
      <Navbar data-id="element-306" data-mp="3kxms6u6ikc5y" />
      <main data-id="element-307" data-mp="3owlus84rvwu8">
        <Hero data-id="element-308" data-mp="3owcdra1ph00o" />
        {showTrustBar ? <TrustBar data-id="element-309" data-mp="3ovas6bn2cv4p" /> : null}
        <Services data-id="element-310" data-mp="3oyyjr58y77gs" />
        <ProjectShowcase data-id="element-311" data-mp="30wjc8ok3us4c" />
        <WhyChooseUs data-id="element-312" data-mp="30x1ec1tg80k6" />
        {showProcessSteps ? <HowItWorks data-id="element-313" data-mp="30up1g32jsgdz" /> : null}
        <About data-id="element-314" data-mp="2vxyb8mx144eu" />
        <Testimonials data-id="element-315" data-mp="2vxf3u0508yf2" />
        <Faq data-id="element-316" data-mp="2vyzydprbkhcx" />
        <ContactForm data-id="element-317" data-mp="2vyht63moissv" />
      </main>
      <Footer data-id="element-318" data-mp="2qylsad9a3hhj" />
      <WhatsAppFloat data-id="element-319" data-mp="2qy2glea81pby" />
    </div>;
}